/* eslint-disable linebreak-style */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import * as Sentry from '@sentry/node';
import { Integrations } from '@sentry/tracing';
import getConfig from 'next/config';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const init = () => {
  Sentry.init({
    dsn: publicRuntimeConfig.sentry || 'https://15b01a2635e540a8a5693409dcb8b5f8@sentry.mcontigo.com/16',
    enabled: process.env.NODE_ENV === 'production',
    debug: process.env.NODE_ENV !== 'production',
    attachStacktrace: true,
    release: process.env.appVersion || publicRuntimeConfig.VERSION,
    environment: process.env.NODE_ENV,
    // beforeSend(event) {
    //   // Check if it is an exception, and if so, show the report dialog
    //   if (event.exception && Sentry.showReportDialog) {
    //     Sentry.showReportDialog({ eventId: event.event_id });
    //   }
    //   return event;
    // },
    integrations: process.browser ? [
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: true
      }),
      // new Integrations.BrowserTracing(), Uncomment to enable sentry monitor.
    ] : [],
    // tracesSampleRate: 1.0, Uncomment to enable sentry monitor.
    whitelistUrls: [new RegExp(publicRuntimeConfig.wp_site_url)],
    // sampleRate: 0.1,
    tags: {
      technology: 'react'
    },
    ignoreErrors: [
      // MC errors
      /kaloo\.ga/,
      /TRCImpl/,
      /getAdKey/,
      /widgetloader/,
      /postMessage/,
      /Intl/,
      /Invalid href passed to router/,
      // Random plugins/extensions
      'top.GLOBALS',
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      'conduitPage',
      // Generic error code from errors outside the security sandbox
      // You can delete this if using raven.js > 1.0, which ignores these automatically.
      'Script error.',
      'Failed to fetch',
    ],
    blacklistUrls: [
      // Ignore Google flakiness
      /\/(gtm|ga|analytics)\.js/i,
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /taboola\.com/i,
      /quantcast/i,
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ]
  });
};

const sentryRedux = () => (next) => (action) => {
  Sentry.addBreadcrumb({
    message: action.type,
    category: 'redux action',
    level: 'info',
    data: {
      payload: action.payload
    }
  });

  return next(action);
};

/**
 * Display messages conditionally. To be used when some
 * message is important but cannot be displayed on production env
 */
const log = process.env.NODE_ENV === 'production' ? (...message) => {
  Sentry.captureMessage(...message);
} : console.log;

export { Sentry, sentryRedux, log, init };
